export const RECURRING = 'Recurring';
export const RUNNING = 'Running';
export const SCHEDULED = 'Scheduled';
export const STARTING = 'Starting';

export enum CampaignState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Draft = 'Draft',
  Finished = 'Finished',
  Ready = 'Ready',
  Recurring = 'Recurring',
  Running = 'Running',
  Recalling = 'Recalling',
  Recalled = 'Recalled',
  Scheduled = 'Scheduled',
}
